import { createSelector } from "reselect"
import { get, remove } from "lodash"
import { numberFormatter } from "helpers/formatters/numbers"
import { makeContributorsGroupDropdownSelector } from "helpers/contributors"
import { sortData } from "helpers/contributorsSort"
import { getSelectedGroupSiblings, getSelectedGroupValue } from "."

const columns = {
  group: [{
    id: "name",
    label: "",
    align: "left",
    getter: get,
  }, {
    id: "totalPercentEquity",
    label: "% Equity",
    getter: get,
    formatter: (number) => numberFormatter(number * 100),
  }, {
    id: "value",
    label: "Absolute",
    getter: get,
    formatter: numberFormatter,
  }],
  details: [{
    id: "label",
    label: "",
    align: "left",
    getter: get,
  }, {
    id: "value",
    label: "% Risk",
    getter: get,
    formatter: (number) => numberFormatter(number * 100),
  }],

}
export const getGroupsDropdownColumns = makeContributorsGroupDropdownSelector(columns)

const getDetails = (state, props) => get(props, "details")
const getGroupOrder = (state, props) => get(props, "groupOrder")
const getShowSegment = (state, props) => get(props, "showSegment")

export const getDropdownItems = createSelector(
  [getSelectedGroupValue, getSelectedGroupSiblings, getDetails, getShowSegment, getGroupOrder],
  (selectedGroup, selectedGroupSiblings, details, showSegment, groupOrder) => {
    if (selectedGroup) {
      return selectedGroupSiblings
    }
    const detailsCopy = [...details]
    if (showSegment) {
      remove(detailsCopy, ({ id }) => id === "total")
    }
    return sortData(detailsCopy, groupOrder)
  },
)
